import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import schoolIcon from 'src/assets/images/school-icon-figma.png';
import communityIcon from 'src/assets/images/community-icon-figma.png';
import learnerIcon from 'src/assets/images/learner-icon-figma.png';
import styles from 'src/components/flows/styles/WhoIsRegistering.module.scss';
import { getStudentPortalUrl } from 'src/config';
import { useIsHofEnded } from 'src/components/flows/Flow';
/**
 * WhoIsRegistering step component
 * Allows user to select their registration type
 * @param {StepProps<WhoIsRegisteringData>} props - Component props
 * @param {WhoIsRegisteringData} props.initialData - Initial form data to restore state
 * @param {Function} props.onDataChange - Callback when form data changes
 * @param {Function} props.onPageValid - Callback when validation state changes
 * @returns {JSX.Element} WhoIsRegistering component
 */
const WhoIsRegistering = ({ initialData, onDataChange, onPageValid, }) => {
    const isHofEnded = useIsHofEnded();
    const selectedType = initialData?.userType;
    /**
     * Handles user type selection
     * @param {UserType} userType - Selected user type
     * @returns {void}
     */
    const handleSelectType = (userType) => {
        onDataChange?.({ userType });
        onPageValid?.(true);
    };
    const options = [
        {
            id: 'school',
            label: 'School Educator',
            icon: schoolIcon,
            ariaLabel: 'Select School',
            description: 'Class, or school organization',
        },
        {
            id: 'community',
            label: 'Community Organization',
            icon: communityIcon,
            ariaLabel: 'Select Community / Organizations',
            description: 'Non-profits and home schools',
        },
        {
            id: 'independent',
            label: 'Independent Learner',
            icon: learnerIcon,
            ariaLabel: 'Select Independent Learner',
            description: (_jsxs(_Fragment, { children: ["Individuals 18+ yr", _jsx("br", {}), "(Completing on my own)"] })),
        },
    ];
    return (_jsxs("div", { className: styles.container, children: [_jsx("div", { className: styles.optionsContainer, children: options.map((option) => (_jsxs("button", { type: "button", className: `${styles.optionCard} ${selectedType === option.id ? styles.selected : ''}`, onClick: () => !isHofEnded && handleSelectType(option.id), "aria-label": option.ariaLabel, role: "radio", "aria-checked": selectedType === option.id, "aria-disabled": isHofEnded, tabIndex: 0, disabled: isHofEnded, onKeyDown: (e) => {
                        if (!isHofEnded && (e.key === 'Enter' || e.key === ' ')) {
                            e.preventDefault();
                            handleSelectType(option.id);
                        }
                    }, children: [_jsx("div", { className: styles.iconWrapper, children: _jsx("img", { src: option.icon, alt: "", role: "presentation" }) }), _jsxs("div", { className: styles.textWrapper, children: [_jsx("span", { className: styles.optionLabel, children: option.label }), _jsx("span", { className: styles.optionDescription, children: option.description })] }), _jsx("div", { className: `${styles.radioButton} ${selectedType === option.id ? styles.selected : ''}` })] }, option.id))) }), !isHofEnded && (_jsx("button", { type: "button", className: styles.studentLink, onClick: () => window.location.href = getStudentPortalUrl(), children: "I'm a student" }))] }));
};
export default WhoIsRegistering;
